import { Component, Prop } from 'vue-property-decorator';
import { changeNumberFormat, applyNumberFixed, fixNumberLength } from '@/assets/common/services'
import { AbstractWidgetContent } from '@/components/Dashboard/Widgets/AbstractWidget/AbstractWidget';
import { WidgetConfigPlantingBudgetAndActualResults, WidgetData } from '@/components/Dashboard/Widgets/types/Widget';
import { PlantingBudgetAndActualResultsResponse } from '@/types/APIResponse';
import { PlantingBudgetAndActualResults, PlantingRate } from '@/types/Component';
import { toCamel } from "snake-camel";
  
import ActualResultsRate from './ActualResultsRate/ActualResultsRate.vue';
import { WidgetContentActualResultsPieChart } from '@/components/Dashboard/Widgets/types/Widget';


@Component({
    filters: {
        applyNumberFixed,
        changeNumberFormat,
        fixNumberLength
    },
    components: {
        ActualResultsRate
    }
})
    
export default class WidgetContentPlantingBudgetAndActualResultsPart extends AbstractWidgetContent<WidgetConfigPlantingBudgetAndActualResults> {
    private isIncome = false
    private isOutgo = false
    private isProfit = true
    private decPointNum = 0
    @Prop()
    public config!: WidgetConfigPlantingBudgetAndActualResults

    private responseItems: PlantingBudgetAndActualResults = {
        plantingId: "",
        plantingName: "",
        incomeProspect: 0,
        budgets: 0,
        workersBudget: 0,
        machinesBudget: 0,
        chemicalsBudget: 0,
        fertilizersBudget: 0,
        materialsBudget: 0,
        totalProspect: 0,
        income: 0,
        outgo: 0,
        workersOutgo: 0,
        machinesOutgo: 0,
        chemicalsOutgo: 0,
        fertilizersOutgo: 0,
        materialsOutgo: 0,
        seedlingsAmount: 0,
        total: 0
    }
    private items = {
        incomeProspect: 0,
        budgets: 0,
        workersBudget: 0,
        machinesBudget: 0,
        chemicalsBudget: 0,
        fertilizersBudget:0,
        materialsBudget: 0,
        totalProspect: 0,
        income: 0,
        outgo: 0,
        workersOutgo: 0,
        machinesOutgo: 0,
        chemicalsOutgo: 0,
        fertilizersOutgo: 0,
        materialsOutgo: 0,
        seedlingsAmount: 0,
        total: 0
    }
    private rates: PlantingRate = {
        incomeRate: '0',
        outgoRate: '0',
        profitRate: '0'
    }
    private pieChartData: WidgetContentActualResultsPieChart = {
        pieChartStatus: 'profit',
        rate: 0,
    }

    created(): void {
        this.getBudgetAndPerformance(this.config.plantingId, this.config.startDate, this.config.endDate)
    }

    refresh(widgetData: WidgetData): void {
        this.isIncome = false
        this.isOutgo = false
        this.isProfit = true
        if (typeof widgetData == 'object') {
            this.$set(this.config, 'plantingId', widgetData.config.plantingId)
            this.$set(this.config, 'unit', widgetData.config.unit)
            this.$set(this.config, 'startDate', widgetData.config.startDate)
            this.$set(this.config, 'endDate', widgetData.config.endDate)
        }
        this.getBudgetAndPerformance(this.config.plantingId, this.config.startDate, this.config.endDate)
    }

    private getBudgetAndPerformance(plantingId: string, startDate: string, endDate: string) {
        let url = `/admin/budget_and_actual_results/plantings/${plantingId}`;
        if (plantingId === '作付未指定') {
            url += `/${startDate}/${endDate}`;
        }
        this.$apiClient.doRequest('get', url).then((ret: PlantingBudgetAndActualResultsResponse) => {
            const res = toCamel(ret) as PlantingBudgetAndActualResults
            this.responseItems = res
            this.items = {
                incomeProspect: this.getLabelNum(this.responseItems.incomeProspect),
                budgets: this.getLabelNum(this.responseItems.budgets),
                workersBudget: this.getLabelNum(this.responseItems.workersBudget),
                machinesBudget: this.getLabelNum(this.responseItems.machinesBudget),
                chemicalsBudget: this.getLabelNum(this.responseItems.chemicalsBudget),
                fertilizersBudget: this.getLabelNum(this.responseItems.fertilizersBudget),
                materialsBudget: this.getLabelNum(this.responseItems.materialsBudget),
                totalProspect: this.getLabelNum(this.responseItems.totalProspect),
                income: this.getLabelNum(this.responseItems.income),
                outgo: this.getLabelNum(this.responseItems.outgo),
                workersOutgo: this.getLabelNum(this.responseItems.workersOutgo),
                machinesOutgo: this.getLabelNum(this.responseItems.machinesOutgo),
                chemicalsOutgo: this.getLabelNum(this.responseItems.chemicalsOutgo),
                fertilizersOutgo: this.getLabelNum(this.responseItems.fertilizersOutgo),
                materialsOutgo: this.getLabelNum(this.responseItems.materialsOutgo),
                seedlingsAmount: this.getLabelNum(this.responseItems.seedlingsAmount),
                total: this.getLabelNum(this.responseItems.total)
            }
            this.getRates()
            this.changeGraphView('profit')
        })
    }

    private getLabelNum(value: number) {
        return value / this.config.unit.value
    }

    private getRates() {
        this.rates = {
            incomeRate: this.calRate(this.responseItems.income , this.responseItems.incomeProspect) ,
            outgoRate: this.calRate(this.responseItems.outgo , this.responseItems.budgets) ,
            profitRate: this.calRate(this.responseItems.total , this.responseItems.totalProspect)
        }
    }

    private calRate(numerator: number , denominator: number) {
        return (numerator / denominator * 100).toFixed(this.decPointNum)
    }

    private changeGraphView(graphView: string) {
        this.isIncome = false
        this.isOutgo = false
        this.isProfit = false

        switch (graphView) {
            case 'income':
                this.isIncome = true
                this.pieChartData = {
                    pieChartStatus: graphView,
                    rate: this.normalizeData(this.rates.incomeRate)
                }
                break
            case 'outgo':
                this.isOutgo = true
                this.pieChartData = {
                    pieChartStatus: graphView,
                    rate: this.normalizeData(this.rates.outgoRate)
                }
                break
            case 'profit':
                this.isProfit = true
                this.pieChartData = {
                    pieChartStatus: graphView,
                    rate: this.normalizeData(this.rates.profitRate)
                }
                break
        }
    }

    private normalizeData(data: string) {
        return isFinite(Number(data)) ? Number(data) : 0
    }
    
}